import React from 'react';
import clsx from 'clsx';

import { ReactComponent as MerchantLogoPlaceholderIcon } from 'assets/merchant-logo-placeholder.svg';

import {
  MERCHANT_LOGO_IMAGE_TEST_ID,
  MERCHANT_LOGO_LOADING_TEST_ID,
  MERCHANT_LOGO_PLACEHOLDER_TEST_ID,
  MERCHANT_LOGO_TEST_ID,
} from './MerchantLogo.test-ids';

import styles from './MerchantLogo.module.scss';

interface MerchantLogoProp {
  logoSrc?: string;
  className?: string;
}
export const MerchantLogo: React.FC<MerchantLogoProp> = ({ logoSrc, className, ...props }) => {
  const [isLogoLoading, setIsLogoLoading] = React.useState(true);
  const [showPlaceholder, setShowPlaceholder] = React.useState(!logoSrc); // if no logo src, initialise placeholder straight away
  const merchantClassNames = clsx(styles.merchantLogo, className);

  if (showPlaceholder) {
    return (
      <div className={merchantClassNames} data-testid={MERCHANT_LOGO_TEST_ID} {...props}>
        <MerchantLogoPlaceholderIcon data-testid={MERCHANT_LOGO_PLACEHOLDER_TEST_ID} />
      </div>
    );
  }

  return (
    <div className={merchantClassNames} data-testid={MERCHANT_LOGO_TEST_ID} {...props}>
      {isLogoLoading && <div className={styles.loadingLogo} data-testid={MERCHANT_LOGO_LOADING_TEST_ID} />}
      <img
        src={logoSrc}
        className={isLogoLoading ? styles.hiddenLogo : ''}
        onLoad={() => setIsLogoLoading(false)}
        onError={() => setShowPlaceholder(true)}
        alt=''
        data-testid={MERCHANT_LOGO_IMAGE_TEST_ID}
      ></img>
    </div>
  );
};

export default MerchantLogo;
